import { assertNever } from '@tableau/data-structures';
import * as React from 'react';
import { SvgSchemaViewerBlank } from '../../../../gen-src/icons/SchemaViewerBlank';
import { SvgSchemaViewerBoolDiscrete } from '../../../../gen-src/icons/SchemaViewerBoolDiscrete';
import { SvgSchemaViewerCurrencyDiscrete } from '../../../../gen-src/icons/SchemaViewerCurrencyDiscrete';
import { SvgSchemaViewerDateDiscrete } from '../../../../gen-src/icons/SchemaViewerDateDiscrete';
import { SvgSchemaViewerDateTimeDiscrete } from '../../../../gen-src/icons/SchemaViewerDateTimeDiscrete';
import { SvgSchemaViewerNumberDiscrete } from '../../../../gen-src/icons/SchemaViewerNumberDiscrete';
import { SvgSchemaViewerTextDiscrete } from '../../../../gen-src/icons/SchemaViewerTextDiscrete';
import { RemoteType } from '../../../../gen-src/queries/globalTypes';

export function RemoteTypeIcon(props: { remoteType: RemoteType }): JSX.Element {
  // References for mapping https://opengrok/source/xref/teams_near/modules/connectors/tabmixins/main/db/OLEDBProtocol.cpp#2389
  // https://opengrok/source/xref/teams_near/modules/platform/tabdoc/main/interface/DataTypeIcons.cpp
  // https://opengrok/source/xref/teams_near/modules/platform/tabcore/public/core/TableauDBType

  switch (props.remoteType) {
    case RemoteType.BOOL:
    case RemoteType.WDC_BOOL:
      return <SvgSchemaViewerBoolDiscrete />;
    case RemoteType.CY:
      return <SvgSchemaViewerCurrencyDiscrete />;
    case RemoteType.DATE:
    case RemoteType.DBDATE:
    case RemoteType.WDC_DATE:
      return <SvgSchemaViewerDateDiscrete />;
    case RemoteType.DBTIME:
    case RemoteType.DBTIMESTAMP:
    case RemoteType.FILETIME:
    case RemoteType.WDC_DATETIME:
      return <SvgSchemaViewerDateTimeDiscrete />;
    case RemoteType.I1:
    case RemoteType.I2:
    case RemoteType.I4:
    case RemoteType.I8:
    case RemoteType.NUMERIC:
    case RemoteType.NULL:
    case RemoteType.R4:
    case RemoteType.R8:
    case RemoteType.UDT:
    case RemoteType.UI1:
    case RemoteType.UI2:
    case RemoteType.UI4:
    case RemoteType.UI8:
    case RemoteType.DECIMAL:
    case RemoteType.VARNUMERIC:
    case RemoteType.WDC_FLOAT:
    case RemoteType.WDC_INT:
      return <SvgSchemaViewerNumberDiscrete />;
    case RemoteType.ARRAY:
    case RemoteType.BSTR:
    case RemoteType.BYREF:
    case RemoteType.BYTES:
    case RemoteType.GUID:
    case RemoteType.STR:
    case RemoteType.WSTR:
    case RemoteType.VARIANT:
    case RemoteType.VECTOR:
    case RemoteType.WDC_STRING:
      return <SvgSchemaViewerTextDiscrete />;
    case RemoteType.EMPTY:
    case RemoteType.ERROR:
    case RemoteType.HCHAPTER:
    case RemoteType.IDISPATCH:
    case RemoteType.IUNKNOWN:
    case RemoteType.PROPVARIANT:
    case RemoteType.RESERVED:
    case RemoteType.WDC_GEOMETRY:
      return <SvgSchemaViewerBlank />;
    default:
      assertNever(props.remoteType);
      return <SvgSchemaViewerBlank />;
  }
}
